<template>
   <div>
      <vs-popup :active.sync="isPromptPopupActive" :title="title">
         <div class="card">
            <div class="card-body py-0">
               <div class="row align-items-center">
                  <div class="col-3 pl-0">
                     <img :src="currentProductImgUrl" alt="icon" class="rounded-circle w-100">
                  </div>
                  <div class="col-9 text-right">
                     <h5 class="card-title font-14">{{currentProductName}}</h5>
                     <h4 class="mb-1">{{currentPriceFormat}}</h4>
                     <span class="badge mt-2 font-11" :class="badgeClass">{{currentStock}} disponibles</span>
                  </div>
               </div>
               <hr class="my-3">
               <div class="row align-items-center mt-2">
                  <div class="col-lg-7 col-6 text-right">
                     <span class="font-15">Cantidad:</span>
                  </div>
                  <div class="col-lg-5 col-6 text-right">
                     <input type="number" class="form-control form-control-high" :class="{'is-invalid': hasError}"  name="inputPieces" id="inputPieces" min="1" v-model="currentPieces">
                  </div>
               </div>
               <div class="row align-items-center mt-2">
                  <div class="col-lg-5 offset-lg-7 col-10 offset-2 text-right mb-2">
                     <div class="input-group mt-1">
                        <div class="input-group-prepend">
                           <span class="input-group-text">$</span>
                        </div>
                        <input type="text" class="form-control-plaintext pl-3 form-control-mid" name="inputStaticValue" id="inputStaticValue" readonly v-model="formattedAmount" >
                     </div>
                  </div>
                  <div class="col-12 text-right mt-1" v-if="errorMssg">
                     <div class="text-error">{{errorMssg}}</div>
                  </div>
               </div>
               <hr class="mb-3 mt-2">
               <div class="row">
                  <div class="col-12" v-if="showSaveAndContinueBtn">
                     <button type="button" class="btn btn-info float-right mt-1 mb-3 ml-auto" @click.stop="onAddProductAndContinue" >
                        {{onEditMode ? saveAndContinueBtnUpdateText : saveAndContinueBtnAddText }}
                     </button>
                  </div>
                  <div class="col-12" v-if="showSaveAndActionBtn">
                     <button type="button" class="btn btn-primary float-right mt-1 mb-1 ml-auto" @click.stop="onAddProductAndGoToCart">
                        {{onEditMode ? saveAndActionBtnUpdateText : saveAndActionBtnAddText }}
                     </button>
                  </div>
               </div>
               <hr class="mt-3 mb-2">
               <div class="row">
                  <div class="col-12">
                     <button type="button" class="btn btn-link float-right ml-auto" @click.stop="onPromptCancel">Cancelar</button>
                  </div>
               </div>
            </div>
         </div>
      </vs-popup>
   </div>
</template>

<script>
import {Product} from "@classes/product"
import formatHelper from "@mixins/formatHelper"
export default {
   name: "ProductPromt",
   mixins: [formatHelper],
   props: {
      product: { type: [Product, Object] },
      onEditMode: { type: Boolean, default: false },
      initialPieces: { type: Number, default: 1 },

      onAddTitle: { type: String, default: "Agregar producto" },
      onUpdateTitle: { type: String, default: "Actualizar producto" },

      showSaveAndContinueBtn: { type: Boolean, default: false },
      saveAndContinueBtnAddText: { type: String, default: "Agregar y continuar comprando" },
      saveAndContinueBtnUpdateText: { type: String, default: "Actualizar y continuar comprando" },

      showSaveAndActionBtn: { type: Boolean, default: false },
      saveAndActionBtnAddText: { type: String, default: "Agregar y ver el carrito" },
      saveAndActionBtnUpdateText: { type: String, default: "Actualizar y ver el carrito" },
   },
   data() {
      return {
         currentPieces: 1,
         currentAmount: 0,
         formattedAmount: null,
         //thumbnailUrl: "https://i.ibb.co/TcVZypR/mini-product.png",
         thumbnailUrl: "https://img.sidi-e.com/120x120/4070017.png",
         errorMssg: null,
      }
   },
   created() {
      this.ERROR_NOT_VALID_QUANTITY = "Por favor defina una cantidad válida."
      this.ERROR_STOCK_OVERFLOW = "No es posible agregar más elementos de los que hay disponibles."
   },
   watch: {
      currentPieces(n,o){
         this.updateProductUI()
      },
      isPromptPopupActive(n){
         if(n){
            this.errorMssg = null
            this.currentPieces = this.initialPieces
            this.updateProductUI()
         }
      }
   },
   computed: {
      isPromptPopupActive: {
         get() {
            return this.$store.state.isProductPromptPopupActive;
         },
         set(val) {
            this.$store.commit("TOGGLE_IS_PRODUCT_PROMPT_POPUP_ACTIVE", val);
         }
      },
      title(){
         return (this.onEditMode) ? this.onUpdateTitle : this.onAddTitle
      },
      currentProductName(){
         return (this.product) ? this.product.name : "-"; 
      },
      currentPriceFormat(){
         let p = (this.product) ? this.product.cost : 0; 
         return this.explicitMoneyFormat(p);
      },
      currentProductImgUrl(){      
         if(this.product){
            return Product.getCartImgUrl(this.product) ?? this.thumbnailUrl;
         }
         return this.thumbnailUrl;
      },
      currentStock(){
         return (this.product) ? this.product.stock : 0; 
      },
      badgeClass(){
         let c = "";
         if(this.currentStock <= 3){
            c = "danger"
         }
         else if(this.currentStock <= 10){
            c = "warning"
         }
         else {
            c = "success"
         }
         return `badge-${c}`;
      },
      hasError() {
         return this.errorMssg != null
      }
   },
   methods: {
      updateProductUI(){
         if(!this.product){
            return
         }
         this.currentAmount = Math.max(this.product.cost * this.currentPieces, 0)
         this.formattedAmount = this.fixedFormat(this.currentAmount, 2)
      },
      async onAddProductAndContinue(){
         if(this.validateQuantity()){
            this.$emit('on-save-product-and-continue', this.currentPieces);
         }
      },
      async onAddProductAndGoToCart(){
         if(this.validateQuantity()) {
            this.$emit('on-save-product-and-action', this.currentPieces);
         }
      },
      async onPromptCancel(){
         this.$store.commit("TOGGLE_IS_PRODUCT_PROMPT_POPUP_ACTIVE", false);
      },
      validateQuantity(){
         let rpieces = parseInt(this.currentPieces)
         if(Number.isNaN(rpieces) || this.rpieces < 1) {
            this.errorMssg = this.ERROR_NOT_VALID_QUANTITY
            return false
         }
         if(this.rpieces > this.currentStock){
            this.errorMssg = this.ERROR_STOCK_OVERFLOW
            return false
         }
         this.errorMssg = null
         return true
      }
   }
   
}
</script>